import { render } from "./InquiryListForm.vue?vue&type=template&id=e6b3efce"
import script from "./InquiryListForm.vue?vue&type=script&lang=js"
export * from "./InquiryListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__